import { render } from "./IreStatsWidget.vue?vue&type=template&id=34ef14f7&scoped=true&ts=true"
import script from "./IreStatsWidget.vue?vue&type=script&lang=ts"
export * from "./IreStatsWidget.vue?vue&type=script&lang=ts"

import "./IreStatsWidget.vue?vue&type=style&index=0&id=34ef14f7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ef14f7"]])

export default __exports__